import { createTrackingEvent } from '../functions/createTrackingEvent';
// Portal specific tracking events
export const DUMMY_TRACKING_EVENT = createTrackingEvent('PORTAL_DUMMY');
export const PAGE_CHANGE_EVENT = createTrackingEvent('PAGE_CHANGE');
export const BUTTON_CLICK_EVENT = createTrackingEvent('BUTTON_CLICK');
export const MODAL_OPEN_CLOSE_EVENT = createTrackingEvent('MODAL_OPEN_CLOSE');
export const WINDOW_FOCUS_EVENT = createTrackingEvent('WINDOW_FOCUS');
